import { gql, useMutation } from "@apollo/client";

import { DISPLAY_NOTIFICATION, notificationEventBus } from "app/notificationsEventBus";
import { ChatChannelResolveInput, ChatChannelResolvePayload } from "types/graphql";

export const CHAT_CHANNEL_RESOLVE = gql`
  mutation ChatChannelResolve($input: ChatChannelResolveInput!) {
    chatChannelResolve(input: $input) {
      successful
      result {
        id
        status
        externalId
      }
      errors {
        message
      }
    }
  }
`;

const displaySuccess = () => {
  notificationEventBus.dispatch(DISPLAY_NOTIFICATION, {
    type: "success",
    message: `The channel was resolved successfully.`,
  });
};

const displayError = (errorMessage: string) => {
  notificationEventBus.dispatch(DISPLAY_NOTIFICATION, {
    type: "danger",
    message: errorMessage,
  });
};

export const useMarkChatAsResolved = () => {
  const [markChatAsResolved, { loading }] = useMutation<
    { chatChannelResolve: ChatChannelResolvePayload },
    { input: ChatChannelResolveInput }
  >(CHAT_CHANNEL_RESOLVE, {
    onCompleted: ({ chatChannelResolve: { successful, errors } }) => {
      if (successful) displaySuccess();
      else {
        const errorMessage = errors.map(({ message }) => message).join(", ");

        displayError(errorMessage);
      }
    },
    onError: () => displayError("There was an error with channel resolving."),
  });

  return {
    isLoading: loading,
    markChatAsResolved: async (externalId: string) => {
      await markChatAsResolved({
        variables: { input: { externalId } },
      });
    },
  };
};
